import workspaceQuery from 'graphql/queries/product/LuckinsItemWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/product/LuckinsItemListQuery.graphql';
import instanceQuery from 'graphql/queries/product/LuckinsItemQuery.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const LuckinsItem = {
  type: 'LuckinsItem',
  title: 'Luckins Products',
  formUrl: '/Products/Luckins/LuckinsItems/Details/',
  workspaceUrl: '/Products/Luckins/LuckinsItems/Workspace/',
  workspace: workspaceQuery,
  enquiryUrl: '/Products/Luckins/LuckinsItems/Enquiry/',
  list: listQuery,
  instance: instanceQuery,
  formTitle: 'Luckins View',
  screenReference: 'LUCKINS_PRODUCTS',
  operations: ALLOW_VIEW | ALLOW_EDIT,
};

export default LuckinsItem;
